{
    "SSO_Login_Title": "Signature unique (SSO)",
    "SSO_Login_Description": "Veuillez patienter, nous validons les données de l'utilisateur. Cela ne devrait pas prendre longtemps.",
    "SSO_Login_Error": "Désolé, nous ne sommes pas en mesure de vous localiser. Veuillez réessayer. Si le problème persiste, veuillez contacter votre administrateur d'application.",
    "SSO_MissingCode_Error": "Désolé, quelque chose n'a pas fonctionné. Veuillez réessayer. Si le problème persiste, veuillez contacter votre administrateur d'application.",
    "NAME": "SSOLanguage"
}